<template>
    <div class="row mb-3">
        <b-col sm="5" class="pt-1">
            <b-form-checkbox v-model="form.checked" switch @change="toggle">
                {{ mission.title }}
            </b-form-checkbox>
        </b-col>
        <b-col sm="3" class="text-right pt-1">
            <span v-if="activateFrequency">
                Fréquence
            </span>
            <span v-if="mission.type === 'tss' && form.checked"> Montant </span>
        </b-col>
        <b-col sm="4">
            <b-form-select
                v-if="activateFrequency"
                v-model="form.periodicity"
                size="sm"
                class="mb-0"
                :options="periodicityOptions"
                @change="update"
            />
            <b-form-select
                v-if="mission.type === 'tss' && form.checked"
                v-model="form.other_option"
                size="sm"
                class="mb-0"
                :options="otherOptions"
                @change="update"
            />
        </b-col>
    </div>
</template>

<script>
import ToastHandler from '../../../invoicing/mixins/ToastHandler.vue'

export default {
    name: 'MissionHandler',

    mixins: [ToastHandler],

    props: {
        mission: {
            type: Object,
            required: true,
        },
        clientId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            form: {
                checked: false,
                periodicity: 'M',
                other_option: 0,
            },
            periodicityOptions: [
                {value: 'A', text: 'Annuelle'},
                {value: 'S', text: 'Semestrielle'},
                {value: 'T', text: 'Trimestrielle'},
                {value: 'M', text: 'Mensuelle'},
            ],
            otherOptions: [
                {value: 0, text: 'Moins de 1 200 €'},
                {value: 1, text: 'Entre 1 200€ et 3 999€'},
                {value: 2, text: 'Entre 4 000€ et 10 000€'},
                {value: 3, text: 'Plus de 10 000€'},
            ],
        }
    },
    computed: {
        activateFrequency() {
            return this.form.checked && (this.mission.type === 'sit' || this.mission.type === 'rep' || this.mission.type === 'ten')
        }
    },

    created() {
        this.initForm()
    },

    methods: {
        initForm() {
            this.form.checked = this.mission.checked
            if (this.activateFrequency) {
                this.form.periodicity = this.mission.periodicity
            } else {
                this.form.periodicity = 'M'
            }
            this.form.other_option =
                this.mission.type === 'tss' ? this.mission.other_option : 0
            this.form.source_mission_id = this.mission.source_mission_id
        },

        async toggle() {
            if (this.form.checked) {
                await this.enable()
            } else {
                await this.disable()
            }
        },

        async enable() {
            this.showRecordingToast()
            try {
                const response = await this.$axios.post(
                    `clients/${this.clientId}/clientMissions/enable`,
                    this.form
                )
                this.handleRecordingResponse(response.data.meta)
                this.$emit('mission-has-changed')
            } catch (error) {
                //
            }
        },

        async disable() {
            this.showRecordingToast()
            try {
                const response = await this.$axios.put(
                    `clients/${this.clientId}/clientMissions/${this.mission.client_mission_id}/disable`
                )
                this.handleRecordingResponse(response.data.meta)
                this.$emit('mission-has-changed')
            } catch (error) {
                //
            }
        },

        async update() {
            this.showRecordingToast()
            try {
                const response = await this.$axios.put(
                    `clients/${this.clientId}/clientMissions/${this.mission.client_mission_id}`,
                    this.form
                )
                this.handleRecordingResponse(response.data.meta)
                this.$emit('mission-has-changed')
            } catch (error) {
                //
            }
        },
    },
}
</script>

<style scoped></style>
